const Heart = props => (
  <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Heart</title>
    <path d="M12.0038 5.88859C13.6847 3.774 15.7139 2.8204 18.0915 3.02778C21.7181 3.34335 24.152 7.62558 19.2295 14.2651C15.1874 19.7223 12.8546 20.7591 12.1927 20.9551L11.9982 21L11.9076 20.9822C11.4089 20.8651 9.04341 20.0434 4.7669 14.266C-0.150943 7.62558 2.28291 3.34335 5.90864 3.02778C8.2868 2.8204 10.3185 3.774 12.0038 5.88859Z" />
  </svg>
);

export { Heart };
